import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Collapse,
  Descriptions,
  Drawer,
  Empty,
  Image,
  Modal,
  Row,
  Tag,
  Typography,
  message,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, redirect, useParams } from "react-router-dom";
import {
  CheckCircleFilled,
  FileAddOutlined,
  LockOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import "./style.css";
import Testimonials from "../../../components/Testimonials";
import EnrolledStudents from "./list";
import AddContent from "./addcontent";
import { isContain } from "./isContain";
import axios from "axios";
import {
  EnrollCoursePaymentService,
  EnrollCourseService,
} from "../../../services/courses/enroll";
import { GetProfileService } from "../../../services/auth/getprofile";

const { Title, Text } = Typography;

const { Panel } = Collapse;

const tabList = [
  {
    key: "User Info",
    tab: "Course Info",
  },
  {
    key: "About Me",
    tab: "About Course",
  },
];

const LearnCourse = () => {
  const getuser = useSelector((state) => state.getuser).result;
  const [activeTabKey1, setActiveTabKey1] = useState("User Info");
  const { id } = useParams();
  const dispatch = useDispatch();
  const [content, setContent] = useState(null);
  const [fetchingContent, setFetchingContent] = useState(false);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [enrolling, setSetEntrolling] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [contentUrl, setContentUrl] = useState("");
  const getcourse = useSelector((state) => state.getcourses).result.filter(
    (obj) => obj.course._id === id
  )[0];
  let isEnrolled = getuser?.result?.Courses.includes(id);
  const showModal = () => {
    setOpen1(true);
  };
  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen1(false);
      setConfirmLoading(false);
    }, 2000);
  };
  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen1(false);
  };
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const [expandIconPosition, setExpandIconPosition] = useState("1");
  const onPositionChange = (newExpandIconPosition) => {
    setExpandIconPosition(newExpandIconPosition);
  };
  const onChange = (key) => {
    console.log(key);
  };
  const genExtra = () => (
    <SettingOutlined
      onClick={(event) => {
        event.stopPropagation();
      }}
    />
  );

  const onTab1Change = (key) => {
    setActiveTabKey1(key);
  };
  const handleContent = async () => {
    setFetchingContent(true);
    const res = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/courses/getcontent?course_id=${id}`
    );
    if (res.error) {
      alert("Error while fetching course content");
    } else {
      console.log(res.data);
      setContent(res.data);
    }
    setFetchingContent(false);
    console.log(content);
  };
  useEffect(() => {
    console.log(id);
    if (isEnrolled) {
      handleContent();
    }
  }, []);
  const handleEnroll = async () => {
    setSetEntrolling(true);
    const key = "updatable";
    messageApi.open({
      key,
      type: "loading",
      content: "Loading...",
    });
    if (getcourse.course.fee > 0) {
      const res = await EnrollCoursePaymentService(
        getcourse.course.fee,
        getcourse.course._id,
        getuser?.result._id,
        dispatch
      );
      console.log("res:", res);
      // TODO add payment confirmation modal here and redirect to course page after successful transaction
      messageApi.open({
        key,
        type: "success",
        content: "Please Wait..",
      });
    } else {
      const res = await EnrollCourseService(id, getuser?.result._id);
      messageApi.open({
        key,
        type: "success",
        content: res,
      });
      await GetProfileService(getuser?.result._id, dispatch);
      window.location.replace(`/dashboard/courses/${id}`);
    }
    handleContent();
    setSetEntrolling(false);
    return;
  };
  const openModal = (url) => {
    setContentUrl(url);
    setModalVisible(true);
  };

  const closeModal = () => {
    setContentUrl("");
    setModalVisible(false);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <Row>
          <Title level={1} className="my-6">
            <span className="text-blue-600">{getcourse.course.title}</span>
          </Title>
        </Row>

        <div className="flex items-center justify-between mb-8">
          <div className="text-lg font-bold">
            Students Enrolled:
            <span className="text-blue-600 cursor-pointer" onClick={showDrawer}>
              (Open)
            </span>
          </div>
        </div>
        {!getuser?.result?.isTeacher && (
          <div className="text-lg font-bold">
            Status:{" "}
            <span
              className={`text-${
                isEnrolled ? "green" : "red"
              }-600 cursor-pointer`}
            >
              {isEnrolled ? "Enrolled" : "Not Enrolled"}
            </span>
          </div>
        )}
        <Row>
          <Title level={4}>Course Details</Title>
        </Row>
        <div className="row d-flex justify-content-center">
          <div className="col-md-12">
            <div className=" p-3 py-4">
              <Card
                style={{
                  width: "100%",
                }}
                tabBarExtraContent={
                  isContain(getuser?.result?.Courses, id) &&
                  getuser?.result?.isTeacher ? (
                    <Button
                      onClick={showModal}
                      type="primary"
                      className="bg-blue-500"
                      icon={<FileAddOutlined />}
                    >
                      Add Content
                    </Button>
                  ) : !isEnrolled ? (
                    <Button
                      onClick={() => {}}
                      type="success"
                      className="bg-blue-500"
                      icon={<FileAddOutlined />}
                    >
                      Enroll
                    </Button>
                  ) : (
                    <Button
                      onClick={() => {}}
                      type="primary"
                      className="bg-blue-500 text-white"
                      icon={<CheckCircleFilled />}
                    >
                      Enrolled
                    </Button>
                  )
                }
                tabList={tabList}
                activeTabKey={activeTabKey1}
                onTabChange={onTab1Change}
              >
                {activeTabKey1 === tabList[0].key && (
                  <Descriptions title="" bordered>
                    <Descriptions.Item label="Status">
                      <span
                        className={`text-${
                          isEnrolled ? "green" : "red"
                        }-600 cursor-pointer`}
                      >
                        {isEnrolled ? "Enrolled" : "Not Enrolled"}
                      </span>
                    </Descriptions.Item>
                    <Descriptions.Item label="Name">
                      {getcourse.course.title}
                    </Descriptions.Item>
                    <Descriptions.Item label="Tags">
                      {getcourse.course.tags &&
                        getcourse.course.tags[0].split(",").map((t) => {
                          return (
                            <Tag
                              color={
                                tags_colors[
                                  Math.floor(Math.random() * tags_colors.length)
                                ]
                              }
                            >
                              {t}
                            </Tag>
                          );
                        })}
                    </Descriptions.Item>
                    <Descriptions.Item label="Duration">
                      {getcourse.course.duration} Weeks
                    </Descriptions.Item>
                    <Descriptions.Item label="Starting Date">
                      {getcourse.course.startDate}
                    </Descriptions.Item>
                    <Descriptions.Item label="End Date">
                      {getcourse.course.endDate}
                    </Descriptions.Item>
                    <Descriptions.Item label="Fee">
                      Rs.{getcourse.course.fee}
                    </Descriptions.Item>
                  </Descriptions>
                )}
                {activeTabKey1 === tabList[1].key && (
                  <Descriptions title="" bordered>
                    <Descriptions.Item label="Description">
                      {getcourse.course.description}
                    </Descriptions.Item>
                  </Descriptions>
                )}
              </Card>
            </div>
          </div>
        </div>
        <Row>
          <Title level={4}>What Will You Learn</Title>
        </Row>
        <ul className="pl-6 text-gray-600 flex flex-col my-3">
          <li>
            <strong>Objective 1:</strong> Build interactive user interfaces with
            React.js.
            <ul className="list-disc ml-6 mt-2">
              <li>
                Understand React.js fundamentals, including components, state,
                and props.
              </li>
              <li>
                Learn how to create reusable UI components for efficient
                development.
              </li>
              <li>
                Implement event handling and data flow within React.js
                applications.
              </li>
            </ul>
          </li>
          <li>
            <strong>Objective 2:</strong> Style web applications using Tailwind
            CSS.
            <ul className="list-disc ml-6 mt-2">
              <li>
                Gain proficiency in Tailwind CSS utility classes for rapid
                styling.
              </li>
              <li>
                Customize and extend Tailwind CSS with configuration options.
              </li>
              <li>
                Apply responsive design techniques using Tailwind CSS
                breakpoints.
              </li>
            </ul>
          </li>
          <li>
            <strong>Objective 3:</strong> Develop responsive and modern web
            applications.
            <ul className="list-disc ml-6 mt-2">
              <li>
                Learn how to combine React.js and Tailwind CSS for responsive
                layouts.
              </li>
              <li>
                Implement responsive navigation menus and mobile-friendly
                interfaces.
              </li>
              <li>
                Utilize React.js libraries and Tailwind CSS plugins to enhance
                functionality.
              </li>
            </ul>
          </li>
        </ul>
        <Row>
          <Title level={4}>Courses Content</Title>
        </Row>
        <div className="container">
          {!isEnrolled && !getuser?.result?.isTeacher && (
            <div className="flex items-center justify-center mt-8 flex-col">
              <button
                className="flex items-center justify-center bg-blue-500 text-white py-4 px-4 rounded-lg hover:bg-blue-600 mr-4 text-lg"
                onClick={handleEnroll}
              >
                <LockOutlined className="mr-3" />{" "}
                {enrolling ? "Please Wait..." : "Enroll Now"}
              </button>
              <img src={require("./enroll-now.jpg")} alt="" />
            </div>
          )}
          {isEnrolled && (
            <>
              <Collapse
                defaultActiveKey={["1"]}
                onChange={onChange}
                expandIconPosition={expandIconPosition}
              >
                {fetchingContent && (
                  <Panel header="Loading..." key="1" extra={genExtra()}></Panel>
                )}
                {!fetchingContent && !content?.length && (
                  <div className="flex items-center justify-center my-8 pb-4 flex-col text-lg">
                    <Empty />
                    Nothing to Show
                  </div>
                )}
                {!fetchingContent &&
                  content &&
                  content.map((c) => {
                    return (
                      <>
                        <Panel
                          header={c.content.title}
                          key={c._id}
                          extra={genExtra()}
                        >
                          <Title level={4}>{c.content.title}</Title>
                          {/* <Title level={5}>Video Lecture</Title>
                  <div className="lecture_card">
                    <div className="lecture_img">
                      <img src={require("./video.png")} alt="" srcset="" />
                    </div>
                    <div className="lecture_name">
                      Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                      Odio ab soluta alias error
                    </div>
                  </div> */}
                          <Title level={5}>PDF Notes</Title>
                          <div
                            className="lecture_card"
                            // onClick={() => window.open(c.file_url, "_blank")}
                            onClick={() => openModal(c.file_url)}
                          >
                            <div className="lecture_img">
                              <img
                                src={require("./pdf.png")}
                                alt=""
                                srcset=""
                              />
                            </div>

                            <div className="lecture_name">
                              <Text>{c.content.description}</Text>
                            </div>
                          </div>
                        </Panel>
                      </>
                    );
                  })}
              </Collapse>

              <div className="flex items-center justify-center mt-8 flex-col">
                <img src={require("./enroll-now.jpg")} alt="" />
              </div>
            </>
          )}
        </div>
      </div>
      <Modal
        title="Content Viewer"
        open={modalVisible}
        onCancel={closeModal}
        onClose={closeModal}
        footer={null}
        width={1000}
      >
        {contentUrl && (
          <iframe
            src={contentUrl}
            title="Content Viewer"
            width="100%"
            height="500px"
          />
        )}
      </Modal>
      <Modal
        title="Add Content"
        open={open1}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        width={1000}
      >
        <AddContent course_id={id} />
      </Modal>
      <Drawer
        title="Students Enrolled"
        placement="right"
        onClose={onClose}
        open={open}
      >
        <EnrolledStudents id={id} />
      </Drawer>
    </>
  );
};

export default LearnCourse;

const tags_colors = [
  "magenta",
  "red",
  "volcano",
  "orange",
  "gold",
  "lime",
  "green",
  "cyan",
  "blue",
  "geekblue",
  "purple",
];
